import axios from "axios";

// import * as types from 'types';

const url = "/image";

export const fetchImage = (id: string) => axios.get(`${url}/${id}`);
